import React from 'react';
import { roundedNumberFormatter, numberFormatter } from '../formatters/numberFormatter';

import JsBarcode from 'jsbarcode';
import moment from 'moment';

const print = async (printData) => {
  const { settingData, userName,  price, date, invoiceId, className, registrationDate, expiryDate } = printData;


  

  const generateBarcode = (id) => {   
    if (!id) return '';  // Return empty string if no ID 
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, id, { 
      format: 'CODE128',
      width: 1,
      height: 40,
      displayValue: false,
    });
    return canvas.toDataURL(); // Returns the barcode as a data URL
  };
  
  const barcodeDataUrl = invoiceId ? generateBarcode(invoiceId) : '';
  
  // Log the data URL to verify the barcode generation
  console.log("Barcode Data URL:", barcodeDataUrl);
  
  

  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
  <style>
  @media print {
    @page {
      margin: 0;
    }
    body {
      margin: 0;
      padding: 0;
      font-family: 'Arial', sans-serif;
    }
  }
  .receipt {
    width: 95%;
    margin: 0;
    padding: 1%;
    border: 0px solid #e0e0e0;
    border-radius: 0px;
  }
  .header {
    text-align: center;
    margin-bottom: 10px; /* Further reduced bottom margin */
    border-bottom: 1px solid #414448;
    color: black;
    padding-bottom: 10px; /* Minimal padding */
  }
  .header h1,
  .header p {
    margin: 0;
  }
  .header h1 {
    margin-bottom: 2px; /* Reduced margin */
  }
  .header p {
    margin-top: 0;
  }
  .details {
    margin-bottom: 0; /* Removed bottom margin */
    border-bottom: 1px solid #414448;
    padding-bottom: 5px; /* Slightly more padding for visual separation */
    color: black;
    font-size: 1rem;
    width: 100%;
  }
  .detailsFlex {
    display: flex;
    justify-content: space-between;
    color: black;
  }
  .items {
    margin-bottom: 10px; /* Reduced bottom margin */
    padding-bottom: 2px; /* Minimal padding */
    color: black;
  }
.note-section {
  text-align: center;
  font-weight: 700;
  font-size: 1rem;
  margin-top: 0px; /* Minimal margin */
  padding-top: 0px; /* Minimal padding */
  color: black;
}


  .table {
    width: 100%;
    margin-top: 5px; /* Reduced top margin */
    font-size: 1rem;
  }
  .th {
    padding-top: 5px; /* Reduced top padding */
    text-align: left;
    font-weight: bold;
    color: black;
  }
  .td {
  text-align: left;
  color: black;
  max-width: 180px;
  word-wrap: break-word;
  white-space: normal;
}

.price-td {
  text-align: right;
  padding-right: 10px;

}

.price-th {
  text-align: right;
  padding-right: 10px;
  font-weight: bold;
}

  .discount {
    border-top: 1px solid #414448;
    font-size: 1rem;
    margin-top: 2px; /* Minimized margin between sections */
    padding-top: 2px; /* Minimal padding */
    color: black;
  }
  .summary {
    border-top: 1px solid #414448;
    margin-top: -2px; /* Adjusted negative margin */
    padding-top: 2px; /* Minimal padding */
    font-size: 1rem;
    color: black;
  }
  .total {

    margin-top: -2px; /* Adjusted negative margin */
    padding-top: 2px; /* Minimal padding */
    font-size: 1rem;
    color: black;
  }

  .summary p {
  margin: 0; /* Remove margin to avoid extra space */
  padding: 0; /* Remove padding */
}

  .total p {
  margin: 1; /* Remove margin to avoid extra space */
  padding: 1; /* Remove padding */
}

  .detailsp {
  margin: 0; /* Remove margin to avoid extra space */
  padding: 0; /* Remove padding */
}
  .details-flex {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Ensure items are aligned vertically */
}
  .total {
    font-weight: 700;
    font-size: 1rem;
  }
  .footer {
    text-align: center;
    font-size: 0.9em;
    color: black;
    padding-top: 2px; /* Minimal padding */
    border-top: 1px solid #ddd;
    width: 100%;
  }
    .footer p {
    margin-bottom: 20px;
}
  .barcode {
    display: block;
    margin: 10px auto;
    width: 150px;
    height: 50px;
  }
  .date {
    text-align: center;
    font-size: 0.9rem;
    margin-bottom: 5px; /* Reduced bottom margin */
    color: black;
  }
    .class-section {
  margin-bottom: 10px;
}

.price-section {
  margin-top: 20px;
}

</style>
        </head>
        <body>
         <div class="receipt">  
            <header class="header">
              <h1>${settingData.printingName}</h1>
              <p>${settingData.printingAddress}</p>
              <p>${settingData.printingPhone}</p>
            </header>


             <section class="details">
              <div class="detailsFlex">
                <p><strong>Served By:</strong> ${userName}</p>
                <p><strong>Invoice#:</strong> ${invoiceId}</p>
              </div>
            </section>

              


     <section class="items">
  <table class="table">
    <thead>
      <tr>
        <th class="th">Class</th>
        <th class="td price-th">Price</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="td">${className}</td>
        <td class="td price-td">${price}</td>
      </tr>
    </tbody>
  </table>
</section>


     ${registrationDate && expiryDate ? ` 
       <section class="summary">
              <div class="detailsFlex">
                <p><strong>Registration Date:</strong></p>
                <p>${moment(registrationDate).format('MM-DD-YYYY')}</p>
                
              </div>  
              <div class="details-flex">
                <p><strong>Expiry Date:</strong></p>
                  <p>${moment(expiryDate).format('MM-DD-YYYY')}</p>
                  
              </div>
                </section>
                ` : ''}

                 <section class="total">
              <div class="details-flex">
               <p ><strong>Total:</strong></p>
              <p>${price}</p>
              </div>
                </section>

                <section class="note-section">       
                    <p>${settingData.printingNote}</p>          
                </section>


           <footer class="footer">
     <p class="date">
     ${moment(date).format('MM-DD-YYYY hh:mm A')}

        </p>
          ${barcodeDataUrl ? `<img src="${barcodeDataUrl}" alt="Barcode" class="barcode" />` : ''}
          <p style="text-align: center; color: black;">By Riser Software</p>
          <p style="text-align: center; color: black; margin-top: -20px;">Whatsapp: 78937719</p>
          <p style="text-align: center; color: black; margin-top: -20px;">www.riserteam.com</p>
        </footer>
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      printWindow.close(); 
    }, 200); // 1 second delay
    
  }
};

export default print;
